/**
 * Per-page hydration entry for /pricing.
 */
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Pricing } from '@/pages/Pricing.tsx';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <Pricing />
    </StrictMode>,
  );
}
